$.fn.toggleAttr = function(attributeName, isForce, attributeValue = "") {
	if (isForce) {
		$(this).attr(attributeName, attributeValue)
	} else {
		$(this).removeAttr(attributeName);
	}

	return this;
};
